import React from 'react'
import { fetchNudgeQueue } from '../../../lib/nudgeApi'
import { getLastSeenMessages } from '../../../lib/notificationStorage'
import type { NudgeStatus } from '../../../types/enums'

const NOTIFY_STATUSES: NudgeStatus[] = ['REPLY_RECEIVED', 'CONV_ACTIVE', 'RECOVERED']

function activityTimestamp(updatedAt: string, replyReceivedAt?: string | null): number {
  return new Date(replyReceivedAt ?? updatedAt).getTime()
}

export function useMessagesNotification(): number {
  const [count, setCount] = React.useState(0)

  React.useEffect(() => {
    let cancelled = false

    function compute() {
      const lastSeen = getLastSeenMessages()
      fetchNudgeQueue(0, 200)
        .then(data => {
          if (cancelled) return
          const unseen = data.content.filter(
            r =>
              NOTIFY_STATUSES.includes(r.status) &&
              activityTimestamp(r.updatedAt, r.replyReceivedAt) > lastSeen,
          )
          setCount(unseen.length)
        })
        .catch(() => {/* keep previous count */})
    }

    compute()
    return () => { cancelled = true }
  }, [])

  return count
}
